import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../../helpers';
import { ONBOARDING_QUESTIONNAIRES_API_BASE } from '../../constants';

import type { IOnboardingQuestionnaireGeneralInfo } from '../../../../../pages/questionnaires/onboarding/components/forms/general/types';
import type { UpdateOnboardingQuestionnaireGeneralInfoPayload } from './types';

export function createOnboardingGeneralThunks() {
  return {
    updateOnboardingQuestionnaireGeneralInfo: updateOnboardingQuestionnaireGeneralInfo(),
  };
}

function updateOnboardingQuestionnaireGeneralInfo() {
  return createAsyncThunk<
    IOnboardingQuestionnaireGeneralInfo,
    UpdateOnboardingQuestionnaireGeneralInfoPayload
  >(
    'onboardingQuestionnaire/updateOnboardingQuestionnaireGeneralInfo',
    async ({ onboardingQuestionnaireId, data, getAccessTokenSilently }) => {
      const response: IOnboardingQuestionnaireGeneralInfo = await fetchWrapper.patch(
        {
          url: `${ONBOARDING_QUESTIONNAIRES_API_BASE}/${onboardingQuestionnaireId}/general_info`,
          getAccessTokenSilently,
        },
        data,
      );
      return response;
    },
  );
}
